<template>
  <span>
    <router-link :to="'/inventory/stocktakes/' + id" v-if="userHasReadPermission(PermissionTypes.InventoryPermissionTypes.stockTake) || userHasReadPermission(PermissionTypes.InventoryPermissionTypes.stockTakeCount)" :target="target" :class="{'router-link-newtab': newTab}">
      {{name}}
    </router-link>
    <span v-else>
      {{name}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LinkStockTake',
  props: {
    id: Number,
    name: String,
    newTab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
}
</script>
